export default "__VITE_ASSET__Bf9S_mUk__"